export const PACKAGING_TYPE_LABELS = {
    SPOTREBITELSKY: 'Spotrebiteľský obal',
    SKUPINOVY: 'Skupinový obal',
    PREPRAVNY: 'Prepravný obal',
    SERVISNY: 'Servisný obal',
    ECOMMERCE: 'Ecommerce (eshop)',
};

export const PACKAGING_TYPE_OPTIONS = Object.entries(PACKAGING_TYPE_LABELS).map(([value, label]) => ({ value, label }));
